// extracted by css-extract-rspack-plugin
export default {"cls1":"SignupBanner-cls1_obB","cls2":"SignupBanner-cls2_7CG SignupBanner-cls1_obB"};